var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-form", { ref: "deprAdjust", staticClass: "demo-ruleForm" }, [
        _c("div", { staticClass: "simple-form" }, [
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("调整类型")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-1-5x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "adjustType" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择" },
                        model: {
                          value: _vm.adjustType,
                          callback: function($$v) {
                            _vm.adjustType = $$v
                          },
                          expression: "adjustType"
                        }
                      },
                      _vm._l(_vm.deprAdjustTypeList, function(deprAdjustType) {
                        return _c("el-option", {
                          attrs: {
                            label: deprAdjustType.text,
                            value: deprAdjustType.value
                          }
                        })
                      })
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _vm.adjustType == 0
          ? _c("div", { staticClass: "hint block" }, [
              _c("div", { staticClass: "title" }, [_vm._v("基础信息")]),
              _vm._v(" "),
              _c("p", [
                _vm._v("可以调整 1、原值，2、使用年限，3、起算日期，4、残值率")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.adjustType == 1
          ? _c("div", { staticClass: "hint block" }, [
              _c("div", { staticClass: "title" }, [_vm._v("当月折旧")]),
              _vm._v(" "),
              _c("p", [_vm._v("最后/当月折旧值，要回退，重新计算累计折旧")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.adjustType == 2
          ? _c("div", { staticClass: "hint block" }, [
              _c("div", { staticClass: "title" }, [_vm._v("历史重算")]),
              _vm._v(" "),
              _c("p", [
                _vm._v("可以调整 1、原值，2、使用年限，3、起算日期，4、残值率")
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("指定从某个月份/起始月份重新算起")])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ae309b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae309b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/assetFiscal/DeprAdjustTypeSelect.vue
// module id = 2603
// module chunks = 0